/* @flow */

import { blueGrey } from '@e180/ui/lib/token/palette';

export default {
  root: {},
  icon: {
    verticalAlign: 'sub',
    display: 'inline-block',
    marginRight: '0.15em',
    '& svg': {
      fill: blueGrey,
      display: 'block',
    },
  },
};
